import {UserDomain} from './user-domain';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {UserDomainService} from './user-domain.service';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class UserDomainsResolver implements Resolve<UserDomain[]> {
  constructor(private service: UserDomainService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserDomain[]> | Promise<UserDomain[]> | UserDomain[] {
    return this.service.userDomains();
  }

}
